<template>
  <div class="custom-card-container">
    <div class="custom-card-header" :style="computedStyle">
      <h4>{{ loadTittle }}</h4>
    </div>
    <div class="custom-card-body">
      <div class="banner-section">
        <div class="banner-image-wrapper">
          <img class="banner-image" :src="loadImage" alt="Banner Evento" />
          <div class="banner-overlay"></div>
          <!-- Optional: Add a title or subtitle overlay here if needed -->
        </div>
      </div>
      <div class="custom-form-body">
        <vee-form
          ref="formRef"
          :validation-schema="baseFormSchema"
          @submit="send"
          v-slot="{ setFieldValue }"
        >
          <!-- Section 1: Datos generales -->
          <div class="card mb-4">
            <div class="card-header bg-primary text-white">
              <h5 class="fs-6">Datos generales</h5>
            </div>
            <div class="card-body">
              <div class="row">
                <div
                  :class="
                    isStudentForm
                      ? 'col-lg-4 col-sm-12 col-12'
                      : 'col-lg-3 col-sm-12 col-12'
                  "
                >
                  <div class="mb-3">
                    <label>{{ documentType }}</label>
                    <vee-field
                      class="form-control text-uppercase"
                      name="document"
                      type="text"
                      placeholder="Nro de Documento"
                      :disabled="section1Disabled"
                    />
                    <ErrorMessage class="text-danger" name="document" />
                  </div>
                </div>
                <div
                  :class="
                    isTeacherForm
                      ? 'col-lg-2 col-md-6 col-12'
                      : 'col-lg-3 col-md-6 col-12'
                  "
                  v-if="isTeacherForm"
                >
                  <div class="mb-3">
                    <label>Carnet</label>
                    <vee-field
                      class="form-control text-uppercase"
                      name="identity_card"
                      type="text"
                      placeholder="Nro de CI"
                      :disabled="section1Disabled"
                    />
                    <ErrorMessage class="text-danger" name="identity_card" />
                  </div>
                </div>
                <div
                  v-if="!isStudentForm"
                  :class="
                    isTeacherForm
                      ? 'col-lg-2 col-sm-6 col-12'
                      : 'col-lg-3 col-sm-6 col-12'
                  "
                >
                  <div class="mb-3" v-show="oriented.ci || isTeacherForm">
                    <label>Complemento</label>
                    <vee-field
                      class="form-control text-uppercase"
                      name="complement"
                      type="text"
                      placeholder="Ej: 1A"
                      :disabled="section1Disabled"
                    />
                    <ErrorMessage class="text-danger" name="complement" />
                  </div>
                </div>
                <div
                  :class="
                    isTeacherForm
                      ? 'col-lg-2 col-sm-6 col-12'
                      : isStudentForm
                      ? 'col-lg-4 col-sm-6 col-12'
                      : 'col-lg-3 col-sm-6 col-12'
                  "
                >
                  <div class="mb-3 d-flex justify-content-center">
                    <div
                      class="form-group m-t-15 m-checkbox-inline mb-0 custom-radio-ml"
                    >
                      <br />
                      <div class="radio radio-primary">
                        <vee-field
                          id="radioinline1"
                          type="radio"
                          name="nationality"
                          value="1"
                          :disabled="section1Disabled"
                        />
                        <label class="mb-0" for="radioinline1">Nacional</label>
                      </div>
                      <div class="radio radio-primary">
                        <vee-field
                          id="radioinline2"
                          type="radio"
                          name="nationality"
                          value="2"
                          :disabled="section1Disabled"
                        />
                        <label class="mb-0" for="radioinline2"
                          >Extranjero</label
                        >
                      </div>
                    </div>
                  </div>
                  <ErrorMessage class="text-danger" name="nationality" />
                </div>
                <div
                  :class="
                    isTeacherForm
                      ? 'col-lg-3 col-md-6 col-12'
                      : isStudentForm
                      ? 'col-lg-4 col-sm-6 col-12'
                      : 'col-lg-3 col-sm-6 col-12'
                  "
                >
                  <div class="mb-3">
                    <label>Fecha de Nacimiento</label>
                    <vee-field
                      class="form-control text-uppercase"
                      name="birth_date"
                      type="date"
                      placeholder="Fecha de Nacimiento"
                      :disabled="section1Disabled"
                    />
                    <ErrorMessage class="text-danger" name="birth_date" />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-3 col-md-6 col-12">
                  <div class="mb-3">
                    <label>Apellido Paterno</label>
                    <vee-field
                      class="form-control text-uppercase"
                      name="f_last_name"
                      type="text"
                      placeholder="Apellido Paterno"
                      :disabled="section1Disabled"
                    />
                    <ErrorMessage class="text-danger" name="f_last_name" />
                  </div>
                </div>
                <div class="col-lg-3 col-md-6 col-12">
                  <div class="mb-3">
                    <label>Apellido Materno</label>
                    <vee-field
                      class="form-control text-uppercase"
                      name="s_last_name"
                      type="text"
                      placeholder="Apellido Materno"
                      :disabled="section1Disabled"
                    />
                    <ErrorMessage class="text-danger" name="s_last_name" />
                  </div>
                </div>
                <div class="col-lg-6 col-12">
                  <div class="mb-3">
                    <label>Nombre(s)</label>
                    <vee-field
                      class="form-control text-uppercase"
                      name="name"
                      type="text"
                      placeholder="Nombre(s)"
                      :disabled="section1Disabled"
                    />
                    <ErrorMessage class="text-danger" name="name" />
                  </div>
                </div>
              </div>
              <div
                class="d-flex justify-content-end"
                v-if="isStudentForm || isTeacherForm"
              >
                <button
                  type="button"
                  class="btn btn-success"
                  @click="validateSection1"
                  :disabled="section1Disabled || section1Validated"
                >
                  {{
                    isStudentForm
                      ? "Validar Datos Generales"
                      : "Validar Datos de Maestro"
                  }}
                </button>
              </div>
            </div>
          </div>

          <!-- Section 2: Sección de información (auto-filled, disabled) -->
          <div class="card mb-4">
            <div class="card-header bg-secondary text-white">
              <h5 class="fs-6">Sección de información</h5>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2 col-md-5 col-12">
                  <div class="mb-3">
                    <label>Departamento</label>
                    <vee-field
                      class="form-control text-uppercase"
                      name="department"
                      placeholder="Departamento"
                      as="select"
                      :disabled="!section1Validated"
                    >
                      <option value="" disabled>Seleccionar</option>
                      <option value="LA PAZ">LA PAZ</option>
                      <option value="COCHABAMBA">COCHABAMBA</option>
                      <option value="ORURO">ORURO</option>
                      <option value="TARIJA">TARIJA</option>
                      <option value="SANTA CRUZ">SANTA CRUZ</option>
                      <option value="BENI">BENI</option>
                      <option value="CHIMBORAZO">POTOSI</option>
                      <option value="PANDO">PANDO</option>
                      <option value="CHUQUISACA">CHUQUISACA</option>
                    </vee-field>
                    <ErrorMessage class="text-danger" name="department" />
                  </div>
                </div>
                <div class="col-lg-4 col-md-7 col-12">
                  <div class="mb-3">
                    <label>{{ institutionLabel }}</label>
                    <vee-field
                      class="form-control text-uppercase"
                      name="institution"
                      type="text"
                      :placeholder="institutionPlaceHolder"
                      :disabled="!section1Validated"
                    />
                    <ErrorMessage class="text-danger" name="institution" />
                  </div>
                </div>
                <template v-if="isGeneralForm">
                  <div class="col-lg-3 col-md-6 col-12">
                    <div class="mb-3">
                      <label>Ocupación</label>
                      <vee-field
                        class="form-control text-uppercase"
                        name="job"
                        type="text"
                        placeholder="Ocupación"
                        :disabled="!section1Validated"
                      />
                      <ErrorMessage class="text-danger" name="job" />
                    </div>
                  </div>
                  <div class="col-lg-3 col-sm-6 col-12">
                    <div class="mb-3">
                      <label>Cargo</label>
                      <vee-field
                        class="form-control text-uppercase"
                        name="position"
                        type="text"
                        placeholder="Cargo"
                        :disabled="!section1Validated"
                      />
                      <ErrorMessage class="text-danger" name="position" />
                    </div>
                  </div>
                </template>
                <template v-if="isStudentForm">
                  <div class="col-lg-3 col-sm-6 col-12">
                    <div class="mb-3">
                      <label>Nivel</label>
                      <vee-field
                        class="form-control"
                        name="education_level"
                        type="text"
                        :placeholder="Nivel"
                        :disabled="!section1Validated"
                      />
                      <ErrorMessage
                        class="text-danger"
                        name="education_level"
                      />
                    </div>
                  </div>
                  <div class="col-lg-3 col-sm-6 col-12">
                    <div class="mb-3">
                      <label>Grado</label>
                      <vee-field
                        class="form-control text-uppercase"
                        name="school_year"
                        type="text"
                        placeholder="Ej: 5to Secundaria, 3er Semestre"
                        :disabled="!section1Validated || isStudentForm"
                      />
                      <ErrorMessage class="text-danger" name="school_year" />
                    </div>
                  </div>
                </template>
                <template v-if="isTeacherForm">
                  <div class="col-lg-3 col-sm-6 col-12">
                    <div class="mb-3">
                      <label>Materia</label>
                      <vee-field
                        class="form-control text-uppercase"
                        name="matery"
                        type="text"
                        placeholder="Ejemplo: Matemática, Biología..."
                        :disabled="!section1Validated"
                      />
                      <ErrorMessage class="text-danger" name="matery" />
                    </div>
                  </div>
                  <div class="col-lg-3 col-sm-6 col-12">
                    <div class="mb-3">
                      <label class="mb-2 d-block text-center"
                        >Actualmente se encuentra en ejercicio?</label
                      >
                      <div
                        class="form-group m-checkbox-inline mb-0 custom-radio-ml d-flex justify-content-center gap-3"
                      >
                        <div class="radio radio-primary">
                          <vee-field
                            id="radioinline3"
                            type="radio"
                            name="in_service"
                            value="1"
                            :disabled="!section1Validated"
                          />
                          <label class="mb-0" for="radioinline3">Sí</label>
                        </div>
                        <div class="radio radio-primary">
                          <vee-field
                            id="radioinline4"
                            type="radio"
                            name="in_service"
                            value="2"
                            :disabled="!section1Validated"
                          />
                          <label class="mb-0" for="radioinline4">No</label>
                        </div>
                      </div>
                      <ErrorMessage class="text-danger" name="in_service" />
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>

          <!-- Section 3: Sección de contacto -->
          <div class="card mb-4">
            <div class="card-header bg-info text-white">
              <h5 class="fs-6">Sección de contacto</h5>
            </div>
            <div class="card-body">
              <template v-if="isStudentForm">
                <div class="row">
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <div class="mb-3">
                      <label
                        >Nro Celular
                        <span
                          class="text-danger"
                          title="De no tener ingresar del padre o tutor"
                          >?</span
                        ></label
                      >
                      <vee-field
                        class="form-control text-uppercase"
                        name="phone"
                        type="tel"
                        placeholder="Celular/Teléfono"
                        :disabled="!section1Validated"
                      />
                      <ErrorMessage class="text-danger" name="phone" />
                    </div>
                  </div>
                  <div class="col-lg-8 col-md-6 col-sm-12">
                    <div class="mb-3">
                      <label
                        >Correo Electrónico
                        <span
                          class="text-danger"
                          title="De no tener ingresar del padre o tutor"
                          >?</span
                        ></label
                      >
                      <vee-field
                        class="form-control"
                        name="email"
                        type="email"
                        placeholder="Correo Electrónico"
                        :disabled="!section1Validated"
                      />
                      <ErrorMessage class="text-danger" name="email" />
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="row">
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <div class="mb-3">
                      <label>Nro Celular</label>
                      <vee-field
                        class="form-control text-uppercase"
                        name="phone"
                        type="tel"
                        placeholder="Celular/Teléfono"
                        :disabled="!section1Validated"
                      />
                      <ErrorMessage class="text-danger" name="phone" />
                    </div>
                  </div>
                  <div class="col-lg-8 col-md-6 col-sm-12">
                    <div class="mb-3">
                      <label>Correo Electrónico</label>
                      <vee-field
                        class="form-control"
                        name="email"
                        type="email"
                        placeholder="Correo Electrónico"
                        :disabled="!section1Validated"
                      />
                      <ErrorMessage class="text-danger" name="email" />
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>

          <DynamicForm
            :schema="formSchema"
            :disabled="!section1Validated"
          ></DynamicForm>

          <div class="d-flex justify-content-center">
            <button
              class="btn btn-primary text-center"
              :disabled="!section1Validated"
            >
              Registrar Inscripción
            </button>
          </div>
        </vee-form>
      </div>
    </div>
  </div>
</template>

<style scoped>
.banner-section {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 18px;
}

.banner-image-wrapper {
  position: relative;
  width: 100%;
  max-width: 100%;
  aspect-ratio: 16/5;
  /* fallback for browsers that don't support aspect-ratio */
  height: 100%;
  max-height: auto;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 24px rgba(44, 62, 80, 0.13);
  background: #f3f6fa;
  display: flex;
  align-items: center;
  justify-content: center;
}

.banner-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
  display: block;
  border-radius: 16px;
  transition: transform 0.3s cubic-bezier(0.4, 2, 0.6, 1);
  background: #f3f6fa;
}

.banner-image-wrapper:hover .banner-image {
  transform: scale(1.03);
}

.banner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    90deg,
    rgba(44, 62, 80, 0.18) 0%,
    rgba(255, 255, 255, 0.08) 100%
  );
  pointer-events: none;
}

@media (max-width: 900px) {
  .banner-image-wrapper {
    aspect-ratio: 16/7;
    height: 180px;
  }
}

@media (max-width: 600px) {
  .banner-image-wrapper {
    aspect-ratio: 16/10;
    height: 120px;
  }
}

.custom-card-container {
  width: 80%;
  margin: 40px auto;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 18px;
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.18);
  backdrop-filter: blur(4px);
  border: 1px solid rgba(255, 255, 255, 0.18);
  overflow: hidden;
}

.custom-card-header {
  padding: 24px 32px 16px 32px;
  background: transparent;
  border-bottom: 1px solid #e3e3e3;
  text-align: center;
}

.custom-card-header h4 {
  margin: 0;
  font-weight: 700;
  color: #2c3e50;
  letter-spacing: 1px;
}

.custom-card-body {
  padding: 24px 32px 32px 32px;
  background: transparent;
}

.custom-form-body {
  margin-top: 24px;
}

.card.mb-4 {
  background: rgba(255, 255, 255, 0.85) !important;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(44, 62, 80, 0.07);
  border: 1px solid #e3e3e3;
}

.card-header.bg-primary,
.card-header.bg-secondary,
.card-header.bg-info {
  border-radius: 12px 12px 0 0;
  background: linear-gradient(90deg, #6a82fb 0%, #fc5c7d 100%) !important;
  color: #fff !important;
  border: none;
}

.card-header.bg-secondary {
  background: linear-gradient(90deg, #43cea2 0%, #185a9d 100%) !important;
}

.card-header.bg-info {
  background: linear-gradient(90deg, #36d1c4 0%, #5b86e5 100%) !important;
}
</style>

<script setup>
import { onMounted, ref, computed, inject } from "vue";
import axios from "@/services/axiosInstance.js";
import DynamicForm from "@/auth/components/DynamicForm.vue";
import { useRoute } from "vue-router";
import { generateComprobant } from "./comprobant.js";
import { toast } from "vue3-toastify";

const baseServerUrl = process.env.VUE_APP_SERVER_SIDE_URL;
const swal = inject("$swal");
const formRef = ref(null);
const event = ref({});
const oriented = ref({});
const formID = ref(null);
const formData = ref({});
const isFormDisabled = ref(false);
const studentInfo = ref({});
const route = useRoute();
const section1Validated = ref(false);
const section1Disabled = ref(false);
let baseFormSchema = ref({});

// Validate Section 1 logic
const validateSection1 = async () => {
  if (!formRef.value) return;

  const values = formRef.value.values;
  let requiredFields = [
    "document",
    "f_last_name",
    "s_last_name",
    "name",
    "birth_date",
    "nationality",
  ];
  if (isTeacherForm.value) {
    requiredFields.push("identity_card");
  }

  let valid = true;
  for (const field of requiredFields) {
    if (!values[field] || values[field].toString().trim() === "") {
      valid = false;
      break;
    }
  }

  if (!valid) {
    const message = isTeacherForm.value
      ? "Por favor, complete todos los campos obligatorios incluyendo RDA y CI."
      : "Por favor, complete todos los campos obligatorios de Datos generales.";
    toast.error(message);
    return;
  }

  try {
    section1Disabled.value = true;
    const info = { ...values };

    // Add eventId from route params to values
    if (route.params.id) {
      info.eventId = route.params.id;
    } else {
      toast.error("Evento no válido");
      section1Disabled.value = false;
      return;
    }

    if (isTeacherForm.value) {
      await validateTeacherPost(info);
    } else {
      await findEstudentPost(info);
    }

    section1Validated.value = true;
    const successMessage = isTeacherForm.value
      ? "Datos de maestro validados correctamente."
      : "Datos generales validados correctamente.";
    toast.success(successMessage);
  } catch (e) {
    const errorMessage = isTeacherForm.value
      ? "Error al validar los datos del maestro."
      : "Error al validar los datos generales.";
    toast.error(errorMessage);
    section1Disabled.value = false;
  }
};

const validateTeacherPost = async (payload) => {
  try {
    swal.fire({
      title: "Validando datos de maestro...",
      html: `
        <div style="margin: 20px 0;">
          <div style="width: 100%; background-color: #f3f3f3; border-radius: 10px; overflow: hidden;">
            <div id="teacher-progress-bar" style="width: 0%; height: 20px; background: linear-gradient(90deg, #43cea2 0%, #185a9d 100%); border-radius: 10px; transition: width 0.3s ease;"></div>
          </div>
          <p id="teacher-progress-text" style="margin-top: 15px; color: #666;">Verificando datos en el sistema...</p>
        </div>
      `,
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      showCancelButton: false,
      didOpen: () => {
        updateTeacherProgress(20, "Enviando datos al servidor...");
      },
    });

    updateTeacherProgress(50, "Validando credenciales de maestro...");

    const teacherData = {
      carnet: payload.identity_card.toString(),
      rda: payload.document.toString(),
      complemento: payload.complement?.toUpperCase() || "",
      nombre: payload.name.toUpperCase(),
      paterno: payload.f_last_name?.toUpperCase() || "",
      materno: payload.s_last_name?.toUpperCase() || "",
      fecha_nacimiento: payload.birth_date,
    };

    updateTeacherProgress(80, "Verificando información...");

    await axios.post(`/event-enrollment/validate-teacher`, teacherData);

    updateTeacherProgress(100, "¡Validación exitosa!");

    await new Promise((resolve) => setTimeout(resolve, 500));
    isFormDisabled.value = false;
    swal.close();
  } catch (error) {
    swal.close();
    if (error.response?.status === 404) {
      throw new Error(
        "Los datos del maestro no fueron encontrados en el sistema."
      );
    } else if (error.response?.status === 500) {
      throw new Error("Error interno del servidor al validar maestro.");
    } else {
      throw new Error("No se pudieron validar los datos del maestro.");
    }
  }
};

const findEstudentPost = async (payload) => {
  try {
    swal.fire({
      title: "Validando datos de estudiante...",
      html: `
        <div style="margin: 20px 0;">
          <div style="width: 100%; background-color: #f3f3f3; border-radius: 10px; overflow: hidden;">
            <div id="student-progress-bar" style="width: 0%; height: 20px; background: linear-gradient(90deg, #6a82fb 0%, #fc5c7d 100%); border-radius: 10px; transition: width 0.3s ease;"></div>
          </div>
          <p id="student-progress-text" style="margin-top: 15px; color: #666;">Buscando información del estudiante...</p>
        </div>
      `,
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      showCancelButton: false,
      didOpen: () => {
        updateStudentProgress(20, "Enviando datos al servidor...");
      },
    });

    updateStudentProgress(50, "Consultando base de datos...");

    const data = await axios.post(`/structure/find-by-rude-post`, payload);
    studentInfo.value = data.data;
    const info = data.data;

    updateStudentProgress(80, "Procesando información...");

    formData.value = {
      phone: "",
      email: "",
      department: info.department_name.toUpperCase(),
      institution: info.institution_name,
      education_level: info.nivel,
      school_year: info.grade_id,
    };

    updateStudentProgress(100, "¡Información encontrada!");
    isFormDisabled.value = true;

    if (formRef.value) {
      Object.entries(formData.value).forEach(([key, value]) => {
        formRef.value.setFieldValue(key, value);
      });
    }
    await new Promise((resolve) => setTimeout(resolve, 500));
    swal.close();
  } catch (error) {
    swal.close();
    throw new Error("No existen resultados.");
  }
};

const computedStyle = computed(() => {
  const color = oriented.value?.color || "#94b8d7";
  return `background: linear-gradient(to right, rgb(238, 243, 247), ${color}) !important;`;
});

const documentType = computed(() => {
  const mode = oriented.value?.mode || "1";
  switch (+mode) {
    case 1:
      return "CI";
    case 2:
      return "RUDE";
    case 3:
      return "RDA";
    default:
      return "CI";
  }
});

const isGeneralForm = computed(() => oriented.value?.mode === "1");
const isStudentForm = computed(() => oriented.value?.mode === "2");
const isTeacherForm = computed(() => oriented.value?.mode === "3");

const institutionLabel = computed(() => {
  if (isStudentForm.value) {
    return "Institución Educativa";
  } else if (isTeacherForm.value) {
    return "Institución Educativa";
  } else {
    return "Institución / Empresa u Organización";
  }
});

const institutionPlaceHolder = computed(() => {
  if (isStudentForm.value) {
    return "Institución donde estudia";
  } else if (isTeacherForm.value) {
    return "Institución donde trabaja";
  } else {
    return "Institución donde trabaja";
  }
});

const loadImage = computed(() => {
  const filename = event.value?.storage?.banner;
  if (!filename) return `${baseServerUrl}/commons/default.jpg`;
  return `${baseServerUrl}/${filename}`;
});

const loadTittle = computed(() => {
  return event.value?.event?.title || "Formulario de Inscripcion";
});

onMounted(async () => {
  try {
    const response = await axios.get(`/event/${route.params.id}`);
    event.value = response.data;

    oriented.value = response.data.oriented;
    formID.value = response.data.enrollment;

    if (response.data.enrollmentForm) {
      formSchema.value.fields = response.data.enrollmentForm;
    }

    await setupValidationSchema();

    if (isGeneralForm.value) {
      section1Validated.value = true;
      section1Disabled.value = false;
    }
  } catch (error) {
    console.error("Error cargando datos:", error);
    toast.error("Error al cargar el evento");
  }
});

const documentRule = computed(() => {
  const mode = oriented.value?.mode || "1";
  switch (+mode) {
    case 1:
      return "required|ci_format";
    case 2:
      return "required|rude_format";
    case 3:
      return "required|rda_format";
    default:
      return "required|ci_format";
  }
});

const setupValidationSchema = async () => {
  const commonSchema = {
    document: documentRule.value,
    complement: "complemento_format",
    nationality: "required",
    f_last_name: "required|alpha_spaces|min:2|max:30",
    s_last_name: "required|alpha_spaces|min:2|max:30",
    name: "required|alpha_spaces|min:2|max:30",
    phone: "required|phone_format",
    email: "required|email",
    institution: "required|min:3|max:60",
    birth_date: "required",
    department: "required",
  };

  if (isTeacherForm.value) {
    commonSchema.identity_card = "required|ci_format";
  }

  let dynamicSchema = {};
  if (formSchema.value.fields && formSchema.value.fields.length > 0) {
    const { buildValidationRules } = await import(
      "@/form_builder/utils/ValidationRulesForm.js"
    );

    for (const field of formSchema.value.fields) {
      dynamicSchema[field.name] = buildValidationRules(field);
    }
  }

  if (isGeneralForm.value) {
    baseFormSchema.value = {
      ...commonSchema,
      ...dynamicSchema,
      job: "required|alpha_spaces|min:3",
      position: "required|alpha_spaces|min:3",
    };
  } else if (isStudentForm.value) {
    baseFormSchema.value = {
      ...commonSchema,
      ...dynamicSchema,
      education_level: "required",
      school_year: "required",
    };
  } else if (isTeacherForm.value) {
    baseFormSchema.value = {
      ...commonSchema,
      ...dynamicSchema,
      matery: "required|alpha_spaces|min:3",
      in_service: "required",
    };
  } else {
    baseFormSchema.value = {
      ...commonSchema,
      ...dynamicSchema,
      job: "required|alpha_spaces|min:3",
      position: "required|alpha_spaces|min:3",
    };
  }
};

const formSchema = ref({
  fields: [],
});

const send = async (values, { resetForm }) => {
  values.name = values.name.toUpperCase();
  values.f_last_name = values.f_last_name.toUpperCase();
  values.s_last_name = values.s_last_name.toUpperCase();
  values.event_id = route.params.id;
  values.oriented_id = oriented.value.id;
  values.form_type = oriented.value.name;
  values.enrollment_form_id = formID.value;

  if (isTeacherForm.value) {
    values.identity_card = values.identity_card;
    values.document = values.document;
    values.institution = values.institution;
    values.matery = values.matery;
    values.in_service = values.in_service;
  } else if (isStudentForm.value) {
    values.document = values.document;
    values.institution = values.institution;
    values.education_level = values.education_level;
    values.school_year = values.school_year;
  } else if (isGeneralForm.value) {
    values.job = values.job;
    values.position = values.position;
    values.institution = values.institution;
  }

  swal.fire({
    title: "Procesando inscripción...",
    html: `
      <div style="margin: 20px 0;">
        <div style="width: 100%; background-color: #f3f3f3; border-radius: 10px; overflow: hidden;">
          <div id="progress-bar" style="width: 0%; height: 20px; background: linear-gradient(90deg, #6a82fb 0%, #fc5c7d 100%); border-radius: 10px; transition: width 0.3s ease;"></div>
        </div>
        <p id="progress-text" style="margin-top: 15px; color: #666;">Validando datos...</p>
      </div>
    `,
    allowOutsideClick: false,
    allowEscapeKey: false,
    showConfirmButton: false,
    showCancelButton: false,
    didOpen: () => {
      updateProgress(10, "Enviando datos al servidor...");
    },
  });

  try {
    updateProgress(30, "Procesando inscripción...");

    const response = await axios.post("/event-enrollment", values);
    const participant = response.data;

    updateProgress(60, "Inscripción exitosa! Generando comprobante...");

    await new Promise((resolve) => setTimeout(resolve, 800));

    updateProgress(80, "Generando comprobante...");

    try {
      await generateComprobant(participant);
      updateProgress(100, "¡Comprobante generado exitosamente!");
      await new Promise((resolve) => setTimeout(resolve, 500));
      swal.close();

      swal
        .fire({
          title: "¡Inscripción exitosa!",
          html: `
        <div style="text-align: center;">
          <p style="font-size: 16px; margin-bottom: 10px;">Su inscripción ha sido procesada exitosamente</p>
          <p style="font-size: 14px; color: #666;">El comprobante se ha descargado automáticamente y se abrió en una nueva pestaña</p>
        </div>
      `,
          icon: "success",
          allowOutsideClick: false,
          allowEscapeKey: false,
          confirmButtonText: "Volver al Portal",
          confirmButtonColor: "#28a745",
        })
        .then((result) => {
          if (result.isConfirmed) {
            resetForm();
            window.close();
          }
        });
    } catch (error) {
      console.error("Error generando el comprobante:", error);
      swal
        .fire({
          icon: "warning",
          title: "Inscripción exitosa",
          text: "Su inscripción fue procesada correctamente, pero hubo un problema al generar el comprobante.",
          confirmButtonText: "Entendido",
        })
        .then(() => {
          resetForm();
        });
    }
  } catch (error) {
    swal.close();

    console.error("Error en el proceso:", error);

    switch (error.response?.status) {
      case 401:
        swal.fire({
          icon: "error",
          title: "Fuera de tiempo",
          text: "Su inscripción ya no puede ser procesada por estar fuera del tiempo limite de inscripción.",
          confirmButtonText: "Aceptar",
        });
        break;
      case 404:
        swal.fire({
          icon: "error",
          title: "Datos no válidos",
          text: "Alguno de sus datos no es válido, verifique e intente nuevamente.",
          confirmButtonText: "Aceptar",
        });
        break;
      case 409:
        swal.fire({
          icon: "error",
          title: "Participante ya registrado",
          text: "Ya existe un participante registrado con esos datos.",
          confirmButtonText: "Aceptar",
        });
        break;
      case 410:
        swal.fire({
          icon: "error",
          title: "Inscripciones cerradas",
          text: "Las inscripciones para este evento han sido cerradas.",
          confirmButtonText: "Aceptar",
        });
        break;
      default:
        swal.fire({
          icon: "error",
          title: "Error de conexión",
          text: "Conexión inestable.\nPor favor, intente nuevamente más tarde.",
          confirmButtonText: "Aceptar",
        });
    }
  }
};

function updateProgress(percentage, text) {
  const pgrsBar = document.getElementById("progress-bar");
  const pgrsText = document.getElementById("progress-text");

  if (pgrsBar) {
    pgrsBar.style.width = percentage + "%";
  }
  if (pgrsText) {
    pgrsText.textContent = text;
  }
}

function updateTeacherProgress(percentage, text) {
  const pgrsBar = document.getElementById("teacher-progress-bar");
  const pgrsText = document.getElementById("teacher-progress-text");

  if (pgrsBar) {
    pgrsBar.style.width = percentage + "%";
  }
  if (pgrsText) {
    pgrsText.textContent = text;
  }
}

function updateStudentProgress(percentage, text) {
  const pgrsBar = document.getElementById("student-progress-bar");
  const pgrsText = document.getElementById("student-progress-text");

  if (pgrsBar) {
    pgrsBar.style.width = percentage + "%";
  }
  if (pgrsText) {
    pgrsText.textContent = text;
  }
}

const findEstudent = async (code) => {
  try {
    const data = await axios.get(`/structure/find-by-rude/${code}`);
    studentInfo.value = data.data;
    const info = data.data;
    const depto = info.department;
    //console.log("findEstudent section ... ", depto);

    const birthDate = new Date(info.birth);

    // Format for date input (YYYY-MM-DD)
    const dateStr = birthDate.toISOString().split("T")[0];

    formData.value = {
      document: info.code,
      complement: "",
      nationality: "1",
      f_last_name: info.paterno.toUpperCase(),
      s_last_name: info.materno.toUpperCase(),
      name: info.nombre.toUpperCase(),
      phone: "",
      email: "",
      birth_date: dateStr,
      department: info.department_name.toUpperCase(),
      institution: info.institution_name,
      education_level: info.nivel,
      school_year: info.grade_id,
    };
    isFormDisabled.value = true;

    if (formRef.value) {
      Object.entries(formData.value).forEach(([key, value]) => {
        formRef.value.setFieldValue(key, value);
      });
    }
    //-- set info section and disable inputs
  } catch (error) {
    console.log("error :: ", error);
  }
};
</script>
